const panel = {
  width: '100%',
  boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px 0px rgba(0, 0, 0, 0.06)',
  borderRadius: '20px',
};

const Card = {
  baseStyle: {
    p: '24px',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    position: 'relative',
    minWidth: '0px',
    wordWrap: 'break-word',
    backgroundClip: 'border-box',
  },
  variants: {
    panel: (props) => ({
      bg: props.colorMode === 'dark' ? '#0E1633' : 'white',
      ...panel
    })
  },
  defaultProps: {
    variant: 'panel',
  },
};

export const CardComponent = {
  components: {
    Card,
  },
};
